import React, { FC, useEffect, useState } from 'react';

import { Table } from '../../common/table/table';
import { useColumns } from './columns';
import { useGuide } from '../../../hooks/use-guide';

const EquipmentsUnitsTypesTable: FC = () => {
  const [units, setUnits] = useState<EntityBase[]>([]);
  const [loading, setLoading] = useState(false);
  const columns = useColumns();

  const fetchGuide = useGuide('equipment_type', undefined, setLoading);
  
  useEffect(() => {
    fetchGuide().then(setUnits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Table
        title="Типы торгового оборудования"
        data={units}
        columns={columns}
        loading={loading}
        paper={false}
      />
    </>
  );
};

export default EquipmentsUnitsTypesTable;
